import { toTitleCase } from "./string.js";
/**
 * Appends all the checkboxes in a form to a FormData object (whether they are
 * checked or not).
 *
 * @param form The form element.
 * @param data The FormData object to append the checkboxes to.
 */
export function appendCheckboxesToFormData(form, data) {
    /** All the checkbox elements in the form. */
    const boxes = Array.from(form.querySelectorAll('input[type="checkbox"]'));
    //This is so we get the state of all the checkboxes whether they are checked or not. Typically only checked checkboxes get sent.
    boxes.forEach((checkbox) => {
        data.append(checkbox.name, String(checkbox.checked));
    });
}
/**
 * Creates a pretty field name from the name attribute of the input. (Removes
 * the group name as well)
 *
 * @param name The name attribute of the input.
 * @returns The pretty field name.
 */
export function getPrettyFieldName(name) {
    return toTitleCase(name.replace(/([^[]+)\[([^\]]+)]/g, "$2").replace(/[_-]/g, " "));
}
//# sourceMappingURL=forms.js.map